import { useSessionStorage } from 'usehooks-ts';
import { getService } from '../../Helpers/getService';
import { Stream } from '../../Stream';
import ServiceTribute from '../../Tributes/ServiceTribute';
import Banner from '../Shared/Banner';
import { PasswordModal } from '../Shared/PasswordModal';
import { ViewServicesButton } from '../Shared/ViewServicesButton';
import { Header } from './Partials/Header';
import { ServiceDetails } from './Partials/ServiceDetails';

export const ServiceStyle1 = ({
  service,
  isLive,
  serviceHash,
  setService,
  setValidPassword,
  validPassword,
  eosms,
  wasWatching,
  livePlayerSources,
  setSelectedSource,
  selectedSource,
  viewerCount,
  viewerStats,
  universalOverride,
}) => {
  const [redirectDone, setRedirectDone] = useSessionStorage('redirectDone', false);

  if (!redirectDone && service.service.hash === 'pVeYo') {
    return (
      <div className="correct-location">
        <div className="correct-location-header">
          <div className="cl-header-inner">
            <p className="cl-title">Funeral Services</p>
            <p className="cl-paragraph">Please select the funeral service you wish to view.</p>
          </div>

          <div className="cl-action-container">
            <button onClick={() => setRedirectDone(true)} className="accent-button">
              William Blake (Bill) Mason
            </button>
            <a href="https://www.morrisandmorris.co.nz/tributes/?funeral=5Xtjh" className="accent-button">
              Ngaire Katherine May Wilson
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-service-container" key={serviceHash + isLive}>
      {!universalOverride && <Header service={service.service} shareUrl={service.share_url} isLive={isLive} />}
      {service.unlocked ? null : (
        <PasswordModal
          partial
          onPasswordSubmit={(password) => getService(serviceHash, setService, setValidPassword, password)}
          validPassword={validPassword}
        />
      )}
      {!universalOverride && !(service.details_protected && !service.unlocked) ? (
        <Banner isLive={isLive} service={service?.service} showStreamCountdown={!!service.stream_countdown} />
      ) : null}

      {!universalOverride && (isLive || wasWatching) && !(service.stream_protected && !service.unlocked) ? (
        <Stream
          eosms={eosms}
          wasWatching={wasWatching}
          playerSources={livePlayerSources}
          setSelectedSource={setSelectedSource}
          selectedSource={selectedSource}
          isLive={isLive}
          viewerCount={viewerCount}
          viewerStats={viewerStats}
          videos={service?.service?.videos}
        />
      ) : null}
      {!(service.details_protected && !service.unlocked) && <ServiceDetails service={service?.service} timezone={service.timezone} />}
      {!isLive && !universalOverride && service?.service?.videos.length && !wasWatching && !(service.stream_protected && !service.unlocked) ? (
        <Stream
          eosms={eosms}
          wasWatching={wasWatching}
          playerSources={livePlayerSources}
          setSelectedSource={setSelectedSource}
          selectedSource={selectedSource}
          isLive={isLive}
          viewerCount={viewerCount}
          viewerStats={viewerStats}
          videos={service?.service?.videos}
        />
      ) : null}
      {!(service.tributes_protected && !service.unlocked) && (
        <ServiceTribute
          tributes={service?.service?.tributes}
          hasPrimaryContact={!!service.service?.primaryContact}
          serviceHash={serviceHash!}
          canAddTributes={!!service.service?.canAddTributes}
        />
      )}
      <ViewServicesButton service={service} />
    </div>
  );
};
